(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

const headerHeight = () => {
  const header = document.querySelector('.header');
  if( !header) return;
  
  const headerHeight = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  const mainContent = document.querySelector("#MainContent");
  mainContent.style.paddingTop = `${headerHeight}px`;
}

window.addEventListener("DOMContentLoaded", headerHeight);
window.addEventListener("resize", headerHeight);


  } catch(e) { console.error(e); }
})();
})();
